import React from "react";
import "./Ourteam.css";
import Kushal from "../../../src/Assets/Images/TeamImage/Kushal.webp";
import Poonam from "../../../src/Assets/Images/TeamImage/Poonam.webp";
import Hiral from "../../../src/Assets/Images/TeamImage/Hiral.webp";
import Karan from "../../../src/Assets/Images/TeamImage/Karan.webp";
import Shiva from "../../../src/Assets/Images/TeamImage/Shiva.webp";
import Ajay from "../../../src/Assets/Images/TeamImage/Ajay.webp";
import Prafulla from "../../../src/Assets/Images/TeamImage/Prafulla.webp";
import Sawant from "../../../src/Assets/Images/TeamImage/Sawant.webp";
import Sakshi from "../../../src/Assets/Images/TeamImage/Sakshi.webp";
import Vrushti from "../../../src/Assets/Images/TeamImage/Vrushti.webp";
import sejal from "../../../src/Assets/Images/TeamImage/Sejal.webp";
import Aditya from "../../../src/Assets/Images/TeamImage/Aditya.webp";
import ArrowOutwardIcon from "@mui/icons-material/ArrowOutward";
import Asishpal from "../../../src/Assets/Images/TeamImage/Ashish pal.webp";
import Saish from "../../../src/Assets/Images/TeamImage/Saish.webp";
import Syed from "../../../src/Assets/Images/TeamImage/Syed.webp";
import Swapnil from "../../../src/Assets/Images/TeamImage/Swapnil.webp";
import Vinay from "../../../src/Assets/Images/TeamImage/Vinay.webp";
import Muskan from "../../../src/Assets/Images/TeamImage/Muskan.webp";
import Darshan from "../../../src/Assets/Images/TeamImage/Darshan.jpg";
import Abhishek from "../../../src/Assets/Images/TeamImage/Abhishek.webp";
import Ayush from "../../../src/Assets/Images/TeamImage/Ayushsoni.webp";
import Chaitany from "../../../src/Assets/Images/TeamImage/Chaitany Ghadigaonkar.webp";
import Kavita from "../../../src/Assets/Images/TeamImage/Kavita.jpg";
import Yashvi from "../../../src/Assets/Images/TeamImage/Yashvi.webp";
import Shivam from "../../../src/Assets/Images/TeamImage/Shivam.webp";
import Pratham from "../../../src/Assets/Images/TeamImage/pratham.png";
import Siddesh from "../../../src/Assets/Images/TeamImage/Siddesh.jpg";
import Ankush from "../../../src/Assets/Images/TeamImage/Ankush.jpg";
import Avinash from "../../../src/Assets/Images/TeamImage/Avinash.jpg";
import AyushV from "../../../src/Assets/Images/TeamImage/AyushV.jpeg";
import Nikhil from "../../../src/Assets/Images/TeamImage/Nikhil.webp";
import Abhijeet from "../../../src/Assets/Images/TeamImage/Abhijit.webp";
import Sid from "../../../src/Assets/Images/TeamImage/Sid.webp";
import Pranav from "../../../src/Assets/Images/TeamImage/Pranav.webp";
import Jatesh from "../../../src/Assets/Images/TeamImage/Jatesh.webp";
import Niraj from "../../../src/Assets/Images/TeamImage/niraj.png";
import Kaushal from "../../../src/Assets/Images/TeamImage/kaushal.jpeg";
import Keerthik from "../../../src/Assets/Images/TeamImage/keerthik.jpeg";
import Bhushan from "../../../src/Assets/Images/TeamImage/Bhushan.webp";
import Aman from "../../../src/Assets/Images/TeamImage/Aman.webp";
import Ritesh from "../../../src/Assets/Images/TeamImage/Ritesh.webp";


function Ourteamimages() {
  // Define an array of team members with their details
  const teamMembers = [
    {
      name: "Kushal Shah",
      image: Kushal,
      role: "Co-Founder",
      linkedin: "https://www.linkedin.com/in/kushal-shah-132801104/",
    },
    {
      name: "Poonam Shah",
      image: Poonam,
      role: "Co-Founder",
      linkedin: "https://www.linkedin.com/in/poonam-shah-945728a1/",
    },
    // { name: 'Hiral Dalal', image: Hiral, role: 'Co-Founder', linkedin: 'https://www.linkedin.com/in/hiral-dalal-28904713/' },
    {
      name: "Mohamed Sidique",
      image: Sid,
      role: "COO (Chief operating officer)",
      linkedin: "https://www.linkedin.com/in/mohamed-sidique-0258221a/",
    },
    {
      name: "Karan Nanesha",
      image: Karan,
      role: "Web Developer",
      linkedin: "https://www.linkedin.com/in/karan-nanesha-291b68207/",
    },
    {
      name: "Ajay Sharma ",
      image: Ajay,
      role: "Full Stack Developer",
      linkedin: "https://www.linkedin.com/in/ajay-sharma-453348142/",
    },

    {
      name: "Vrushti Ashar",
      image: Vrushti,
      role: "Project Manager",
      linkedin: "https://www.linkedin.com/in/vrushti-ashar-86a852143/",
    },
    {
      name: "Ayush Soni",
      image: Ayush,
      role: "UI/UX Designer",
      linkedin: "https://www.linkedin.com/in/ayush-soni-1310681a2/",
    },
    {
      name: "Sakshi Virulkar",
      image: Sakshi,
      role: "UI/UX Designer",
      linkedin: "https://www.linkedin.com/in/sakshi-virulkar/",
    },
    // {
    //   name: "Aditya Ingle",
    //   image: Aditya,
    //   role: "App Developer",
    //   linkedin: "https://www.linkedin.com/in/aditya-ingle-95b582211/",
    // },
    {
      name: "Ashish Sawant",
      image: Sawant,
      role: "Full Stack Developer",
      linkedin: "https://www.linkedin.com/in/ashish-sawant/",
    },
    {
      name: "Sejal Shah",
      image: sejal,
      role: "Graphic Designer",
      linkedin: "",
    },
    // {
    //   name: "Saish Jagtap",
    //   image: Saish,
    //   role: "Frontend Developer",
    //   linkedin: "https://www.linkedin.com/in/saishj/",
    // },
    // { name: 'Abhishek Dhakad', image: Abhishek, role: 'Full Stack Developer', linkedin: 'https://www.linkedin.com/in/abhishekwebdev/' },
    {
      name: "Ashish Pal",
      image: Asishpal,
      role: "Full Stack Developer",
      linkedin: "https://www.linkedin.com/in/web-developer-ashish-pal/",
    },
    // {
    //   name: "Muskan Saxena",
    //   image: Muskan,
    //   role: "UI/UX Designer Intern",
    //   linkedin: "https://www.linkedin.com/in/muskansaxena09/",
    // },
    // { name: 'Vinay Mange', image: Vinay, role: 'Frontend Developer', linkedin: 'https://www.linkedin.com/in/vinay-mange-b5b700209/' },
    // { name: 'Prafulla Mishra', image: Prafulla, role: 'Software Test Engineer', linkedin: 'https://www.linkedin.com/in/prafulla-mishra-b88921267/' },
    {
      name: "Panchal Swapnil",
      image: Swapnil,
      role: "Software Test Engineer",
      linkedin: "https://www.linkedin.com/in/panchal-swapnil-051069243/",
    },
    // { name: 'Syed Maaz', image: Syed, role: 'Frontend Developer', linkedin: 'https://www.linkedin.com/in/syed-maaz-636477193/' },
    {
      name: "Darshan Chatrawat",
      image: Darshan,
      role: "Full Stack Developer",
      linkedin: "https://www.linkedin.com/in/darshan-chatrawat-13801922b",
    },
    // {
    //   name: "Shivam Pal",
    //   image: Shivam,
    //   role: "Full Stack Intern",
    //   linkedin: "https://www.linkedin.com/in/shivampal7/",
    // },
    // { name: 'Chaitany Ghadigaonkar', image: Chaitany, role: 'Full Stack Developer Intern', linkedin: 'https://www.linkedin.com/in/chaitany-ghadigaonkar/' },
    // {
    //   name: "Kavita Rathod",
    //   image: Kavita,
    //   role: "Assistant Product Manager",
    //   linkedin: "https://www.linkedin.com/in/kavita-rathod",
    // },
    {
      name: "Yashvi Shah",
      image: Yashvi,
      role: "Assistant Product Manager",
      linkedin: "https://www.linkedin.com/in/yashvi-shah-81660b35b/",
    },
    {
      name: "Pratham Vaishya",
      image: Pratham,
      role: "Full Stack Developer",
      linkedin: "https://www.linkedin.com/in/pratham-vaishya-b40b49212/",
    },
    // {
    //   name: "Siddesh Shinde",
    //   image: Siddesh,
    //   role: "Full Stack Developer",
    //   linkedin: "https://www.linkedin.com/in/siddesh-shinde-b2a4a8226/",
    // },
    {
      name: "Ankush Upadhyay",
      image: Ankush,
      role: "Node Developer",
      linkedin:
        "https://www.linkedin.com/in/ankush-upadhyay-5961441b6?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    },
    {
      name: "Avinash Kurmi",
      image: Avinash,
      role: "Frontend Developer",
      linkedin:
        "https://www.linkedin.com/in/avinash-kumar-kurmi-386025241?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    },
    // {
    //   name: "Ayush Vikhrankar",
    //   image: AyushV,
    //   role: "Frontend Developer",
    //   linkedin:
    //     "https://www.linkedin.com/in/ayush-vikharankar-904431259?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app",
    // },
    {
      name: "Pranav Lot",
      image: Pranav,
      role: "Frontend Developer",
      linkedin: "https://www.linkedin.com/in/pranav-lot-541691257",
    },
    {
      name: "Nikhil Shinde",
      image: Nikhil,
      role: "Full Stack Developer",
      linkedin: "https://www.linkedin.com/in/nikhil-shinde-586b49340",
    },
    {
      name: "Abhijeet Vishwakarma",
      image: Abhijeet,
      role: "Full Stack Developer",
      linkedin: "https://www.linkedin.com/in/abhijeet-vishwakarma-386168214/",
    },
    {
      name: "Nirajkumar Jaiswar",
      image: Niraj,
      role: "Software Test Engineer",
      linkedin: "https://www.linkedin.com/in/nirajkumar-jaiswar-69b8911b3/?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    },
    {
      name: "Keerthik Shetty",
      image: Keerthik,
      role: "Full Stack Developer",
      linkedin: "https://www.linkedin.com/in/keerthik-shetty",

    },
    {
      name: "Kaushalkishore Vishwakarma",
      image: Kaushal,
      role: "Full Stack Developer",
      linkedin: "https://www.linkedin.com/in/kaushalkishore07",
    },
    { name: 'Aman Bharati', image: Aman, role: 'QA Intern', linkedin: 'https://www.linkedin.com/in/aman-bharati-mca' },
    { name: 'Bhushan Gamare', image: Bhushan, role: 'UI/UX Design Intern', linkedin: 'https://www.linkedin.com/in/bhushanuiux' },
    { name: 'Ritesh Sawardekar', image: Ritesh, role: 'UI/UX Design Intern', linkedin: 'https://www.linkedin.com/in/uiuxritesh' },

    // { name: '', image: "", role: '', linkedin: '' },

    // Add more team members with their details here
  ];

  return (
    <div className="Ourteamimages">
      <div className="Ourteamimagesbanner">
        {/* Map through the team members and render their details */}
        {teamMembers.map((member, index) => (
          <div className="team-images" key={index}>
            <div className="images-dwb">
              <img src={member.image} alt="" style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
              }} />
            </div>
            <div className="dwb-image-overlay">
              <div className="Dwb-linkedIn">
                <a
                  href={member.linkedin}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <p>LinkedIn</p>
                  <ArrowOutwardIcon />
                </a>
              </div>
              <div className="overlay-anim">
                <div className="marquee-overlay">
                  <ul className="marquee__contentoverlay scroll">
                    <p>{member.role}</p>
                    <p>{member.role}</p>
                    <p>{member.role}</p>
                    <p>{member.role}</p>
                  </ul>
                  <ul
                    className="marquee__contentoverlay scroll"
                    aria-hidden="true"
                  >
                    <p>{member.role}</p>
                    <p>{member.role}</p>
                    <p>{member.role}</p>
                    <p>{member.role}</p>
                  </ul>
                </div>
                <div className="marquee-overlayTwo">
                  <ul className="marquee__contentoverlayTwo scroll">
                    <p className="dwb-dev-name">{member.name}</p>
                    <p className="dwb-dev-name">{member.name}</p>
                    <p className="dwb-dev-name">{member.name}</p>
                    <p className="dwb-dev-name">{member.name}</p>
                  </ul>
                  <ul
                    className="marquee__contentoverlayTwo scroll"
                    aria-hidden="true"
                  >
                    <p className="dwb-dev-name">{member.name}</p>
                    <p className="dwb-dev-name">{member.name}</p>
                    <p className="dwb-dev-name">{member.name}</p>
                    <p className="dwb-dev-name">{member.name}</p>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Ourteamimages;
